module.exports = __webpack_public_path__ + "media/images/site/step-four-7414d182834ea13ae160cafd8a189428.svg";